import {Injectable} from '@angular/core';
import {Storage} from '@ionic/storage';

export const TOKEN_AUTH = '_cau_ge_tokenAuthorization';

@Injectable({
  providedIn: 'root'
})
export class UserProvider {

  constructor(public storage: Storage) {
  }

  setUser(user: any): Promise<any> {
    return this.storage.set('user', user);
  }

  getUser(): Promise<any> {
    return this.storage.get('user');
  }

  setToken(token: any): Promise<any> {
    return this.storage.set('token', token);
  }

  getToken(): Promise<any> {
    return this.storage.get('token');
  }

  setOnboard(): Promise<any> {
    return this.storage.set('onboard', true);
  }

  getOnboard(): Promise<any> {
    return this.storage.get('onboard');
  }

  setVersion(version: any): Promise<any> {
    return this.storage.set('version', version);
  }

  getVersion(): Promise<any> {
    return this.storage.get('version');
  }

  setItemToken(token: string): void {
    localStorage.setItem(TOKEN_AUTH, token);
  }

  getItemToken() {
    return localStorage.getItem(TOKEN_AUTH);
  }

  clearAuthorizationToken(): void {
    localStorage.removeItem(TOKEN_AUTH);
    this.setUser(null);
    this.setToken(null);
  }
}
